import { useState } from 'react';
import type { Me } from './me';

/**
 * Whether to show the user's profile photo, and what to do when it fails.
 *
 * ONE decision, shared by every avatar (the wide rail's account card, the mobile drawer's account
 * row, the Account page's profile card) so they cannot disagree: the photo is `me.profileImage`, and
 * a load failure latches this browser back to the initials for the rest of the session rather than
 * leaving a broken-image glyph in a circle.
 *
 * The latch is per-hook-instance on purpose — a failure in one avatar shouldn't blank the others,
 * and each remounts with a fresh attempt on the next navigation.
 */
export function useProfilePhoto(me: Me | null): { photoUrl: string | null; onPhotoError: () => void } {
  const [failed, setFailed] = useState(false);
  return {
    photoUrl: me?.profileImage && !failed ? me.profileImage : null,
    onPhotoError: () => setFailed(true),
  };
}
